import EventManager from 'dd-event-manager';



const NO_SCROLL_TAG = 'dn-no-scroll';
const SCROLL_EVENT  = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
const SCROLL_JUDGE_INTERVAL = 500;



export default class WindowManager {
  static get RESIZE_EVENT_TAG() { return 'window_resize_handle'; }
  static get SCROLL_EVENT_TAG() { return 'window_scroll_handle'; }



  $h                = null;
  $w                = null;
  $d                = null;
  sizeInitialized   = false;
  scrollInitialized = false;
  allInitialized    = false;
  width             = null;
  height            = null;
  scroll            = {top: null, left: null};
  scrollDiff        = {start: {top: null, left: null}, top: null, left: null};
  scrollTimerId     = null;
  nowScroll         = false;
  loaded            = false;

  hiddenKey           = null;
  visibilityChangeKey = null;



  /**
   * constructor
   */
  constructor() {
    new EventManager(this);

    this.$w = $(window);
    this.$h = $('html');
    this.$d = $(document);

    this.updateSize();

    const tag = WindowManager.RESIZE_EVENT_TAG;

    this.$w.on('load.loadCheck', () => {
      this.$w.off('.loadCheck');
      this.loaded = true;
      this.emit('load', this);
    });

    this.$w.on(`load.${tag} resize.${tag} orientationchange.${tag}`, () => {
      this._updateScrollParams();
      this.updateSize();
    });

    this.$w.on(`scroll.${WindowManager.SCROLL_EVENT}`, () => {
      this._onScroll();
    });

    // this.$w.on(`storage.${tag}`, e => {
    //   this.emit('storage', e);
    // });

    this.setupVisibilityEvent();
  }



  /**
   * check all initialized
   */
  _checkAllInitialized() {
    if (this.allInitialized) return;

    if (this.sizeInitialized && this.scrollInitialized) {
      this.allInitialized = true;
      this.emit('allInitialized');
    }
  }



  /**
   * on scrll callback
   */
  _onScroll() {
    if (!this.nowScroll) {
      this.scrollDiff.start.top  = this.scroll.top;
      this.scrollDiff.start.left = this.scroll.left;
    }

    this._updateScrollParams();

    this.scrollDiff.top  = this.scroll.top  - this.scrollDiff.start.top;
    this.scrollDiff.left = this.scroll.left - this.scrollDiff.start.left;

    if (!this.nowScroll) {
      this.nowScroll = true;
      this.emit('scrollStart', this);
    }

    this.emit('scroll', this);

    if (this.scrollTimerId !== null) {
      clearTimeout(this.scrollTimerId);
      this.scrollTimerId = null;
    }

    this.scrollTimerId = setTimeout(() => {
      this.nowScroll = false;
      this.emit('scrollEnd', this);
    }, SCROLL_JUDGE_INTERVAL);

  }



  /**
   * update scroll params
   */
  _updateScrollParams() {
    this.scroll.top  = this.$w.scrollTop();
    this.scroll.left = this.$w.scrollLeft();
    this.scrollInitialized = true;
    this._checkAllInitialized();
  }



  /**
   * adjust viewport
   */
  viewportAdjust() {
    return new Promise((resolve, reject) => {
      this.hasAndOn('load', () => {
        let ww   = this.$w.width(),
            dw   = this.$d.width(),
            diff = dw - ww;

        if (diff < 0) return;

        let $head = $('head'),
            $vp   = $head.find('meta[name="viewport"]'),
            attr  = $vp.attr('content'),
            scale = ww / dw;

        attr = attr.replace(/initial-scale=1.0/, 'initial-scale=' + scale);
        attr = attr.replace(/maximum-scale=1/, 'maximum-scale=' + scale);
        $vp.attr('content', attr);
        attr = attr.replace('maximum-scale=' + scale, 'maximum-scale=1');
        $vp.attr('content', attr);
      });
    });
  }



  /**
   * set scroll disabled
   */
  setScrollDisabled(disabled = true) {
    if (disabled) {
      this.$h.addClass(NO_SCROLL_TAG);
    } else {
      this.$h.removeClass(NO_SCROLL_TAG);
    }
  }



  /**
   * setup visibility event
   */
  setupVisibilityEvent() {

    const handleVisibilityChange = e => {
      if (document[this.hiddenKey]) {
        this.emit('hide', this);
      } else {
        this.emit('show', this);
      }
    }

    if (document.hidden !== undefined) {
      this.hiddenKey = 'hidden';
      this.visibilityChangeKey = 'visibilitychange';
    } else if (document.mozHidden !== undefined) {
      this.hiddenKey = 'mozHidden';
      this.visibilityChangeKey = 'mozvisibilitychange';
    } else if (document.msHidden !== undefined) {
      this.hiddenKey = 'msHidden';
      this.visibilityChangeKey = 'msvisibilitychange';
    } else if (document.webkitHidden !== undefined) {
      this.hiddenKey = 'webkitHidden';
      this.visibilityChangeKey = 'webkitvisibilitychange';
    }

    if (!this.hiddenKey) {
      console.warn('ブラウザが `Page Visibility API` に対応していないため、イベントの発行を行いません。');
      return;
    }

    if (document.addEventListener === undefined || !this.hiddenKey) {
      console.warn('ブラウザが `Page Visibility API` に対応していないため、イベントの発行を行いません。');
      return;
    }

    document.addEventListener(this.visibilityChangeKey, handleVisibilityChange, false);
  }



  /**
   * update size params
   */
  updateSize() {
    let bw = this.width, bh = this.height;

    this.width  = window.innerWidth;
    this.height = window.innerHeight;
    this.sizeInitialized = true;
    this._checkAllInitialized();

    if (bw !== this.width || bh !== this.height) {
      this.emit('resize', this);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/manager/window-manager/WindowManager.js